import accountGrMasterReducer from 'modules/account-group-master/slice';
import accountMasterReducer from 'modules/account-master/slice';
import airMasterReducer from 'modules/airMasterBL/slice';
import aitGrMasterReducer from 'modules/ait-group-master/slice';
import authReducer from 'modules/auth/slice';
import blMasterExportReducer from 'modules/blMaster-export/slice';
import blMasterReducer from 'modules/blMaster/slice';
import cargoTraceSearchExportReducer from 'modules/cargo-trace-search-export/slice';
import cargoTraceSearchReducer from 'modules/cargo-trace-search/slice';
import chatroomReducer from 'modules/chatroom/slice';
import commonReducer from 'modules/common/slice';
import containerStatusReducer from 'modules/container-status/slice';
import customsClearanceRequestExportReducer from 'modules/customs-clearance-request-export/slice';
import customsClearanceRequestReducer from 'modules/customs-clearance-request/slice';
import deliveryDestMasterReducer from 'modules/delivery-dest-master/slice';
import menuDisplayItemReducer from 'modules/display-item-master/slice';
import documentApprovalReducer from 'modules/document-approval/slice';
import EdiReducer from 'modules/edi/slice';
import generalMasterReducer from 'modules/general-master/slice';
import hblStatusExportReducer from 'modules/hbl-status-export/slice';
import hblStatusReducer from 'modules/hbl-status/slice';
import menuAuthorityMasterReducer from 'modules/menu-authority-master/slice';
import notificationReducer from 'modules/notification/slice';
import OutputReportReducer from 'modules/output-report-search/slice';
import portMasterReducer from 'modules/port-master/slice';
import searchPatternReducer from 'modules/search-pattern/slice';
import shipMovementSearchReducer from 'modules/ship-movement-search/slice';
import statusMasterReducer from 'modules/status-master/slice';
import tabWindowReducer from 'modules/tab-window/slice';
import preAlertExportReducer from 'modules/trace-info-export/pre-alert/slice';
import preAlertReducer from 'modules/trace-info/pre-alert/slice';
import userMastReducer from 'modules/user-maintance/slice';
import { combineReducers } from 'redux';

export default combineReducers({
  common: commonReducer,
  auth: authReducer,
  airMaster: airMasterReducer,
  blMaster: blMasterReducer,
  blMasterExport: blMasterExportReducer,
  cargoTraceSearch: cargoTraceSearchReducer,
  cargoTraceSearchExport: cargoTraceSearchExportReducer,
  shipMovementSearch: shipMovementSearchReducer,
  preAlert: preAlertReducer,
  preAlertExport: preAlertExportReducer,
  edi: EdiReducer,
  outputReportMaster: OutputReportReducer,
  menuDisplayItem: menuDisplayItemReducer,
  tabWindow: tabWindowReducer,
  userMast: userMastReducer,
  accountMaster: accountMasterReducer,
  generalMaster: generalMasterReducer,
  accountGrMaster: accountGrMasterReducer,
  portMaster: portMasterReducer,
  searchPattern: searchPatternReducer,
  documentApproval: documentApprovalReducer,
  hblStatus: hblStatusReducer,
  hblStatusExport: hblStatusExportReducer,
  containerStatus: containerStatusReducer,
  chatroom: chatroomReducer,
  aitGrMaster: aitGrMasterReducer,
  statusMaster: statusMasterReducer,
  menuAuthorityMaster: menuAuthorityMasterReducer,
  customsClearanceRequest: customsClearanceRequestReducer,
  customsClearanceRequestExport: customsClearanceRequestExportReducer,
  deliveryDestMaster: deliveryDestMasterReducer,
  notification: notificationReducer,
});
